import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { LocalStorageService } from '../local-storage/local-storage.service';

@Injectable()
export class AuthGuardService  implements CanActivate {

  constructor(public localStorageService: LocalStorageService, public router: Router) {}

  canActivate(): boolean {

    const customerId = this.localStorageService.getCustomerId();

    if (customerId === undefined || customerId === 'undefined' || customerId === '' || customerId === null) {
      this.router.navigate(['/']);
      return false;
    }
    return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/common-service/auth-guard/auth-guard.service.ts